var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Emit, Prop } from 'vue-property-decorator';
import MaterialIcons from '@/components/material-icons.vue';
var BookmarkCheckbox = /** @class */ (function (_super) {
    __extends(BookmarkCheckbox, _super);
    function BookmarkCheckbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showBookmarkedOnlyLocal = false;
        return _this;
    }
    Object.defineProperty(BookmarkCheckbox.prototype, "effectiveChecked", {
        get: function () {
            return this.checked !== undefined ? this.checked : this.showBookmarkedOnlyLocal;
        },
        enumerable: false,
        configurable: true
    });
    BookmarkCheckbox.prototype.toggleBookmarkFilter = function () {
        var next = !this.effectiveChecked;
        if (this.checked === undefined) {
            this.showBookmarkedOnlyLocal = next;
        }
        return next;
    };
    __decorate([
        Prop({ type: Boolean, default: undefined })
    ], BookmarkCheckbox.prototype, "checked", void 0);
    __decorate([
        Emit('bookmark-filter-change')
    ], BookmarkCheckbox.prototype, "toggleBookmarkFilter", null);
    BookmarkCheckbox = __decorate([
        Component({
            components: { MaterialIcons: MaterialIcons }
        })
    ], BookmarkCheckbox);
    return BookmarkCheckbox;
}(Vue));
export default BookmarkCheckbox;
